// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/holdover-time.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/holdover-time/holdover-time.js';

mount([g0]);
